import React from 'react';
import {Box, Grid} from '@mui/material';
import Typography from '@mui/material/Typography';
import {useLocalization} from 'localization';
import {getShortcutGroupsWithCommands} from 'services/shortcuts';
import {Link} from 'components/button';
import {Panel} from 'components/layout';
import {EditCommand} from './EditCommand';

export const EditShortcuts = () => {
  const {t} = useLocalization();

  return (
    <Box component="form" noValidate autoComplete="off">
      <Grid container spacing={2} mb={2}>
        <Grid size={12}>
          <Panel>
            <Typography variant={'body2'} gutterBottom>
              Her kan du sette egne hurtigtaster dersom noen av de
              forhåndsdefinerte ikke fungerer i din nettleser eller
              operativsystem. Noen hurtigtaster kan være reservert av
              nettleseren eller operativsystemet, og vil da ikke være mulig å
              overstyre. Du kan kombinere med blant annet Ctrl, Shift og Alt
              (Meta eller Cmd på Mac), eller F-taster. Men vær obs på at
              Ctrl+kombinasjoner med en bokstav ofte er reservert i Windows, og
              Cmd+kombinasjoner med en bokstav i MacOS.
            </Typography>
            <Typography variant={'body2'}>
              Det enkleste er nok bare å sette en ny hurtigtast og prøve seg
              frem. Hvis du ønsker å vite mer om hvilke hurtigtaster som er
              reservert i din nettleser, kan du sjekke lenkene under:
            </Typography>
            <ul>
              <li>
                <Link
                  title="Edge med Windows og Mac"
                  to={
                    'https://support.microsoft.com/en-us/microsoft-edge/keyboard-shortcuts-in-microsoft-edge-50d3edab-30d9-c7e4-21ce-37fe2713cfad'
                  }
                />
              </li>
              <li>
                <Link
                  title="Chrome med Windows og Mac"
                  to={'https://support.google.com/chrome/answer/157179'}
                />
              </li>
              <li>
                <Link
                  title="Safari med Mac"
                  to={
                    'https://support.apple.com/no-no/guide/safari/cpsh003/mac'
                  }
                />
              </li>
            </ul>
            <Typography variant={'body2'}>
              For at endringen skal lagres kan du:
            </Typography>
            <ul>
              <li>trykke TAB</li>
              <li>trykke ESCAPE</li>
              <li>
                fokusere ut av feltet (f.eks. trykke med musa utenfor
                input-feltet)
              </li>
            </ul>
            <Typography variant={'body2'}>
              For å fjerne en hurtigtast, kan du slette innholdet i feltet ved
              å:
            </Typography>
            <ul>
              <li>trykke BACKSPACE</li>
              <li>trykke DELETE</li>
            </ul>
          </Panel>
        </Grid>
        {getShortcutGroupsWithCommands(true).map(({group, commands}) => (
          <Grid key={group} size={{lg: 3, md: 6, xs: 12}}>
            <Panel>
              <Typography variant={'h3'}>
                {t(`shortcuts.header.${group}.label`)}
              </Typography>

              <Box display={'flex'} gap={2} flexDirection={'column'} mt={2}>
                {commands.map(command => (
                  <EditCommand key={command} command={command} />
                ))}
              </Box>
            </Panel>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
